import React from 'react';
import { AlertTriangleIcon, XCircleIcon } from 'lucide-react';
export function ProblemSection() {
  return <section className="py-16 md:py-24 bg-white" data-id="element-99">
      <div className="max-w-7xl mx-auto px-5 md:px-8" data-id="element-100">
        <div className="flex flex-col lg:flex-row gap-12 items-center" data-id="element-101">
          <div className="lg:w-1/2" data-id="element-102">
            <img src="https://cdn.magicpatterns.com/uploads/fbC4QRbJqNNgCvj7GaqGei/ChatGPT_Image_22_mar_2026,_19_05_41.png" alt="Mujer cansada vs Mujer con energía" className="rounded-2xl shadow-xl w-full object-cover" data-id="element-103" />
          </div>

          <div className="lg:w-1/2 space-y-6" data-id="element-104">
            <div className="inline-flex items-center space-x-2 bg-red-50 text-red-700 px-4 py-2 rounded-full font-semibold text-sm mb-2" data-id="element-105">
              <AlertTriangleIcon className="h-4 w-4" data-id="element-106" />
              <span data-id="element-107">Estás peleando contra tu propia biología</span>
            </div>

            <h2 className="text-3xl md:text-4xl font-bold text-gray-900 leading-tight" data-id="element-108">
              Lo que nadie te dice es que, después de los 40, tu cuerpo cambia
              las reglas del juego.
            </h2>

            <p className="text-lg text-gray-700" data-id="element-109">
              Tu metabolismo no es "lento"; está{' '}
              <span className="font-bold text-red-600" data-id="element-110">asustado</span>. Vives en
              un estado de alerta constante —estrés laboral, hijos, falta de
              sueño, cambios hormonales—.
            </p>

            <p className="text-lg text-gray-700" data-id="element-111">
              Tu cerebro interpreta esto como un peligro inminente y dispara una
              señal química: <strong data-id="element-112">Cortisol alto</strong>. Esta hormona le
              ordena a tu cuerpo dos cosas:
            </p>

            <ul className="space-y-4 bg-stone-50 p-6 rounded-xl border border-stone-100" data-id="element-113">
              <li className="flex items-start" data-id="element-114">
                <span className="flex-shrink-0 h-6 w-6 rounded-full bg-red-100 text-red-600 flex items-center justify-center font-bold text-sm mr-3 mt-0.5" data-id="element-115">
                  1
                </span>
                <span className="text-gray-800" data-id="element-116">
                  Destruir tu músculo para obtener energía rápida.
                </span>
              </li>
              <li className="flex items-start" data-id="element-117">
                <span className="flex-shrink-0 h-6 w-6 rounded-full bg-red-100 text-red-600 flex items-center justify-center font-bold text-sm mr-3 mt-0.5" data-id="element-118">
                  2
                </span>
                <span className="text-gray-800" data-id="element-119">
                  Almacenar grasa en tu abdomen para "proteger" tus órganos
                  vitales.
                </span>
              </li>
            </ul>

            <p className="text-lg font-medium text-gray-900" data-id="element-120">
              Por eso, cuanto más te esfuerzas en el gimnasio, más se inflama tu
              vientre.
            </p>
          </div>
        </div>

        <div className="mt-20" data-id="element-121">
          <h3 className="text-2xl md:text-3xl font-bold text-center text-gray-900 mb-10" data-id="element-122">
            Por qué lo que intentaste{' '}
            <span className="text-red-600 underline decoration-red-300" data-id="element-123">
              NO funcionó
            </span>
          </h3>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-124">
            <div className="bg-white p-8 rounded-2xl shadow-lg border border-gray-100 relative overflow-hidden group hover:-translate-y-1 transition-transform duration-300" data-id="element-125">
              <div className="absolute top-0 left-0 w-full h-1 bg-red-500" data-id="element-126"></div>
              <XCircleIcon className="h-10 w-10 text-red-500 mb-4" data-id="element-127" />
              <h4 className="text-xl font-bold text-gray-900 mb-3" data-id="element-128">
                El Cardio Intenso
              </h4>
              <p className="text-gray-600" data-id="element-129">
                Eleva aún más el cortisol, diciéndole a tu cuerpo que un
                depredador te persigue, lo que bloquea la quema de grasa.
              </p>
            </div>

            <div className="bg-white p-8 rounded-2xl shadow-lg border border-gray-100 relative overflow-hidden group hover:-translate-y-1 transition-transform duration-300" data-id="element-130">
              <div className="absolute top-0 left-0 w-full h-1 bg-red-500" data-id="element-131"></div>
              <XCircleIcon className="h-10 w-10 text-red-500 mb-4" data-id="element-132" />
              <h4 className="text-xl font-bold text-gray-900 mb-3" data-id="element-133">
                Las Dietas de Hambre
              </h4>
              <p className="text-gray-600" data-id="element-134">
                Disparan alarmas de escasez en tu metabolismo, bajando tu
                temperatura corporal y aumentando la retención de líquidos.
              </p>
            </div>

            <div className="bg-white p-8 rounded-2xl shadow-lg border border-gray-100 relative overflow-hidden group hover:-translate-y-1 transition-transform duration-300" data-id="element-135">
              <div className="absolute top-0 left-0 w-full h-1 bg-red-500" data-id="element-136"></div>
              <XCircleIcon className="h-10 w-10 text-red-500 mb-4" data-id="element-137" />
              <h4 className="text-xl font-bold text-gray-900 mb-3" data-id="element-138">
                El Café en Ayunas
              </h4>
              <p className="text-gray-600" data-id="element-139">
                Es un choque eléctrico para tus glándulas adrenales que provoca
                picos de insulina sin haber probado un bocado.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>;
}